import {
  snowman,
  renovation,
  summerHolidays,
  partyTime,
  travel,
  house,
} from "assets/images";

const data = [
  {
    id: 1,
    title: "Styczeń",
    description: "lorem ipsum dolor sit amet quebo na fide oraz taco hemingway",
    category: {
      src: snowman,
      name: "winter",
    },
    currency: "PLN",
    users: [
      {
        nickname: "Marek",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
      {
        nickname: "Moniak23",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
    ],
  },
  {
    id: 2,
    title: "Wycieczka",
    description: "lorem ipsum dolor si",
    category: {
      src: travel,
      name: "travel",
    },
    currency: "PLN",
    users: [
      {
        nickname: "Tomek",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
      {
        nickname: "Marek",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
    ],
  },
  {
    id: 3,
    title: "Mieszkanie",
    description: "lorem ipsum dolor sit amet quebo na fide oraz taco hemingway",
    category: {
      src: house,
      name: "home",
    },
    currency: "PLN",
    users: [
      {
        nickname: "Marek",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
      {
        nickname: "Moniak23",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
    ],
  },
  {
    id: 4,
    title: "Wakacje",
    description: "lorem ipsum dolor sit amet quebo na fide oraz taco hemingway",
    category: {
      src: summerHolidays,
      name: "holidays",
    },
    currency: "PLN",
    users: [
      {
        nickname: "Marek",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
      {
        nickname: "Moniak23",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
    ],
  },
  {
    id: 5,
    title: "Impreza",
    description: "lorem ipsum dolor sit amet quebo na fide oraz taco hemingway",
    category: {
      src: partyTime,
      name: "party",
    },
    currency: "PLN",
    users: [
      {
        nickname: "Marek",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
      {
        nickname: "Moniak23",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
    ],
  },
  {
    id: 6,
    title: "Remont",
    description: "lorem ipsum dolor sit amet quebo na fide oraz taco hemingway",
    category: {
      src: renovation,
      name: "renovation",
    },
    currency: "PLN",
    users: [
      {
        nickname: "Marek",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
      {
        nickname: "Moniak23",
        picture:
          "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
      },
    ],
  },
];

export default data;
